module.exports = __webpack_public_path__ + "media/images/logo-mercy-fcc6eb4d0b59374eca7b0cb25bc75107.png";